import { ProcedureParams } from '@/backend/access/procedure/types';

export class Procedure {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  title: string;
  description?: string;
  propelOrgId: string;
  viewedAt?: Date | string;
  latestVersion?: string;

  constructor(params: ProcedureParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.title = params.title;
    this.description = params.description;
    this.propelOrgId = params.propelOrgId;
    this.viewedAt = params.viewedAt;
    this.latestVersion = params.latestVersion ?? undefined;
  }
}
